import React from 'react'

// material-ui
import Box from '@mui/material/Box'
import Link from '@mui/material/Link'
import Typography from '@mui/material/Typography'
import { useTheme } from '@mui/material/styles'

// brand
import { useBrand } from 'components/shared/SettingsProvider'
import BrandLogo from 'components/shared/BrandLogo'

const MobileHeader = props => {
  const { title, nav, greeting, logout } = props

  // get brand logo
  const { id } = useBrand()

  // get header background color
  const theme = useTheme()
  const bgcolor = theme.components.DesktopHeader?.Box?.bgcolor || 'black'
  const color = theme.components.DesktopHeader?.Typography?.color || 'white'

  return (
    <>
      <Box width='100%' align='center' color='black' bgcolor='white'>
        <BrandLogo
          brand={id}
          variant='small'
          sx={{
            maxWidth: '30%',
            mt: '1rem',
            mb: '1rem'
          }}
        />
        <Typography
          variant='body1'
          fontWeight='fontWeightMedium'
          position='absolute'
          right='10px'
          top='12px'
        >
          {greeting || (logout && <Link href='/logout'>Log out</Link>)}
        </Typography>
      </Box>
      <Box
        width='100%'
        align='center'
        color='white'
        bgcolor={bgcolor}
        position='relative'
      >
        <Box position='absolute' left='10px' top='8px'>
          {nav}
        </Box>
        <Typography
          variant='body1'
          fontWeight='fontWeightMedium'
          align='center'
          p='1rem'
          color={color}
        >
          {title}
        </Typography>
      </Box>
    </>
  )
}

export default MobileHeader
